import { render } from "./exportTableButton.vue?vue&type=template&id=452a77d4"
import script from "./exportTableButton.vue?vue&type=script&lang=js"
export * from "./exportTableButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__